import { useState } from 'react'
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'

import { Menu, MenuItem, ListItemText, Button } from '@mui/material'
import { Add } from '@mui/icons-material'
import routes from '@/routes'

import UiFeedbackComponent from './ui-feedback/index.component'

const OpenCrudsComponent = () => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  // Open Routes

  const handleOpenBonusProgram = () => {
    navigate(routes.bonus.CREATE_BONUS)
  }

  return (
    <>
      <Button
        variant="contained"
        sx={{
          minWidth: '34px',
          height: '34px',
          borderRadius: '8px',
          p: 0,
          mr: 2,
        }}
        onClick={handleClick}
      >
        <Add />
      </Button>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          style: {
            minWidth: 180,
          },
        }}
        sx={{ marginTop: '17px' }}
      >
        <MenuItem onClick={handleOpenBonusProgram}>
          <ListItemText primary={t('sidebar.bonusProgram')} />
        </MenuItem>
      </Menu>
      <UiFeedbackComponent />
    </>
  )
}

export default OpenCrudsComponent
